import styled from 'styled-components'
import { Breadcrumb as BreadcrumbAntd } from 'antd'

export const Breadcrumb = styled(BreadcrumbAntd)`
  font-family: 'kanit';
`
